export function resaRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_RESERVATION_START":           
        case "UPDATE_RESERVATION_START":           
        case "RECEIVE_RESERVATION_START":           
        case "DELETE_RESERVATION_START":           
        case "FETCH_RESERVATIONS_START":           
        case "FETCH_INIT_DATA2_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_RESERVATION_FULFILLED":           
        case "UPDATE_RESERVATION_FULFILLED":           
        case "RECEIVE_RESERVATION_FULFILLED":           
        case "DELETE_RESERVATION_FULFILLED":           
        case "FETCH_RESERVATIONS_FULFILLED":           
        case "FETCH_INIT_DATA2_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_RESERVATION_ERROR":
        case "UPDATE_RESERVATION_ERROR":
        case "RECEIVE_RESERVATION_ERROR":
        case "DELETE_RESERVATION_ERROR":
        case "FETCH_RESERVATIONS_ERROR":
        case "FETCH_INIT_DATA2_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}